export const incidentStatuses = {
    IN_PROGRESS: 0,
    COMPLETED: 1,
    OUTSTANDING: 2,
    NA: 3,
  };